// Third party import
import React from 'react';

// HA import
import {ButtonPrimary, Button} from '@homeaway/react-buttons';
import {SVGIcon} from '@homeaway/react-svg';
import {ARROW_LEFT__32} from '@homeaway/svg-defs';
import FormSelect from '@homeaway/react-form-select';

// Relative import
import './LandingPage.less';
import ipmConnectImage from '../../images/IPM-hero-1.svg';
import saveTimeIcon from '../../images/save-time-icon.svg';
import syncContentIcon from '../../images/sync-content-icon.svg';
import competitiveEdgeIcon from '../../images/competitive-edge-icon.svg';
import {processTranslation} from '../utils/commonUtil';

class LandingPage extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.props.triggerEdapPageViewAction();
    }

    getCardQuestion = () => {
        let {translations, cardQuestionId} = this.props;
        if (cardQuestionId === 'card_1') {

            return processTranslation(translations['ipmob.landing_page.card_1.head'], ['Vrbo']);

        } else if (cardQuestionId === 'card_2') {
            return translations['ipmob.landing_page.card_2.head'];
        }
        return translations['ipmob.landing_page.card_3.head'];
    };

    getArrowIcon = () => {
        const {cardQuestionId, userType, leftArrowOnClick} = this.props;

        return (cardQuestionId === 'card_2' || cardQuestionId === 'card_3')
            ? (<div className="wrapper">
                <div className={`card-icon ${userType === 'TRAVELER' ? 'default-card' : ''}`}>
                    <div className={`arrow-icon-wrapper ${userType === 'TRAVELER' ? 'hide' : ''}`}
                        onClick={leftArrowOnClick}
                    >
                        <SVGIcon useFill inlineFlex markup={ARROW_LEFT__32}/>
                    </div>
                </div>
            </div>) : null;
    }

    getCardClass = () => {
        if (this.props.cardQuestionId === 'card_3') {
            return 'question-card-3';
        } else if (this.props.cardQuestionId === 'card_2') {
            return 'question-card-2';
        }
        return 'question-card-1';
    };

    getCardQnClass = () => {
        if (this.props.cardQuestionId === 'card_3') {
            return 'card-3-qn';
        } else if (this.props.cardQuestionId === 'card_2') {
            return 'card-2-qn';
        }
        return 'card-1-qn';
    };

    getButton = () => {
        let {translations, cardQuestionId} = this.props;
        if (cardQuestionId === 'card_3') {
            return (
                <div className="card-button-3"><ButtonPrimary label={translations['ipmob.landing_page.section_3.btn']}
                    type="submit" value="Submit" id={'getStarted'}
                    onClick={this.props.handleStartClick}
                                               /></div>);
        }
        return (<div className="card-button"><Button label={translations['ipmob.landing_page.card_1.btn_1']}
            onClick={this.props.handleYesClick}
                                             />
            <Button label={translations['ipmob.landing_page.card_1.btn_2']} onClick={this.props.handleNoClick}/></div>);
    };
    getCardInfo = () => {
        let {translations, cardQuestionId} = this.props;
        if (cardQuestionId === 'card_3') {
            return (<div>
                <div className="wrapper">{translations['ipmob.landing_page.card_3.desc_1']}</div>
                <div className="wrapper">{translations['ipmob.landing_page.card_3.desc_2']}</div>
            </div>);
        }
        return translations['ipmob.landing_page.card_1.desc'];

    };

    getCardInfoClass = () => (this.props.cardQuestionId === 'card_3') ? 'card-info-3' : 'card-info';

    getListItems = () => {
        let {supportedBrands} = this.props;
        const items = supportedBrands && supportedBrands.length > 0 ?
            supportedBrands.map((locales) => ({
                label: locales.brandName,
                value: locales.locale
            })) :
            [];
        return items;
    }



    render() {
        const {
            translations,
            cardQuestionId,
            language,
            handleLanguageSelection
        } = this.props;


        return (<div id="ipmLandingPage" className="ipm-landing-pg">
            <div className="ipm-landing-pg-container">
                <div className="ipm-info-panel">
                    <ipm-landing-section>
                        <ipm-connect-article>
                            <div className="wrapper">
                                <h1 className="ipm-connect-head">
                                    {translations['ipmob.landing_page.section_1.head']}
                                </h1>
                            </div>
                            <div className="wrapper">
                                <span className="ipm-connect-sub-head">
                                    {translations['ipmob.landing_page.section_1.sub_head']}
                                </span>
                            </div>
                            <div className="wrapper">
                                <div className="qns-card-outer">
                                    <div className="qns-card">
                                        {this.getArrowIcon()}
                                        <div className={this.getCardClass()}>
                                            <div className="wrapper">
                                                <h2 className={this.getCardQnClass()}>{this.getCardQuestion()}</h2>
                                            </div>
                                            <div className="wrapper">
                                                {(cardQuestionId === 'card_3') ?
                                                    (<div className="lan-sel">
                                                        <FormSelect
                                                            id="brandSelection"
                                                            name={translations['ipmob.landing_page.card_3.language']}
                                                            items={this.getListItems()}
                                                            label={translations['ipmob.landing_page.card_3.language']}
                                                            value={language}
                                                            onChange={handleLanguageSelection}
                                                        />
                                                    </div>) : null}
                                            </div>
                                            <div className="wrapper">
                                                {this.getButton()}
                                            </div>
                                            <div className="wrapper">
                                                <span className={this.getCardInfoClass()}>
                                                    {this.getCardInfo()}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <img className="ipm-connect-bg-img" src= {ipmConnectImage()}/>
                        </ipm-connect-article>
                    </ipm-landing-section>
                    <ipm-landing-section>
                        <ipm-info-article>
                            <div className="wrapper">
                                <div className="ipm-info-icon info-article-1">
                                    <img src= {saveTimeIcon()}/>
                                </div>
                            </div>
                            <div className="wrapper">
                                <h2 className="ipm-info-head info-article-1">
                                    {translations['ipmob.landing_page.section_2.article_1.head']}
                                </h2>
                            </div>
                            <div className="wrapper">
                                <span className="ipm-info-sub-head info-article-1">
                                    {translations['ipmob.landing_page.section_2.article_1.desc']}
                                </span>
                            </div>
                        </ipm-info-article>
                        <ipm-info-article>
                            <div className="wrapper">
                                <div className="ipm-info-icon info-article-2">
                                    <img src= {syncContentIcon()}/>
                                </div>
                            </div>
                            <div className="wrapper">
                                <h2 className="ipm-info-head info-article-2">
                                    {translations['ipmob.landing_page.section_2.article_2.head']}
                                </h2>
                            </div>
                            <div className="wrapper">
                                <span className="ipm-info-sub-head info-article-2">
                                    {translations['ipmob.landing_page.section_2.article_2.desc']}
                                </span>
                            </div>
                        </ipm-info-article>
                        <ipm-info-article>
                            <div className="wrapper">
                                <div className="ipm-info-icon info-article-3">
                                    <img src= {competitiveEdgeIcon()}/>
                                </div>
                            </div>
                            <div className="wrapper">
                                <h2 className="ipm-info-head info-article-3">
                                    {translations['ipmob.landing_page.section_2.article_3.head']}
                                </h2>
                            </div>
                            <div className="wrapper">
                                <span className="ipm-info-sub-head info-article-3">
                                    {translations['ipmob.landing_page.section_2.article_3.desc']}
                                </span>
                            </div>
                        </ipm-info-article>
                    </ipm-landing-section>
                    <ipm-landing-section>
                        <ipm-get-start-article>
                            <div className="wrapper">
                                <h1 className="ipm-get-started-head">{translations['ipmob.landing_page.section_3.head']}</h1>
                            </div>
                            <div className="wrapper get-started-btn">
                                <ButtonPrimary label={translations['ipmob.landing_page.section_3.btn']} type="submit" value="Submit" id={'getStarted'} onClick = {this.props.handleGetStartedClick}/>
                            </div>
                        </ipm-get-start-article>
                    </ipm-landing-section>
                    <ipm-landing-section>
                        <ipm-qns-article>
                            <div className="wrapper">
                                <h1 className="ipm-qns-head">{translations['ipmob.landing_page.section_4.head']}</h1>
                            </div>
                            <div className="wrapper">
                                <div className="ipm-qns-article-1">
                                    <div className="wrapper">
                                        <h4 className="qns-1">{translations['ipmob.landing_page.section_4.sub_head_1']}</h4>
                                    </div>
                                    <div className="wrapper">
                                        {
                                            // eslint-disable-next-line react/no-danger
                                            <span className="answer" dangerouslySetInnerHTML={{__html: translations['ipmob.landing_page.section_4.desc_1']}}/>
                                        }
                                    </div>
                                </div>
                                <div className="ipm-qns-article-2">
                                    <div className="wrapper">
                                        <h4 className="qns-1">{translations['ipmob.landing_page.section_4.sub_head_2']}</h4>
                                    </div>
                                    <div className="wrapper">
                                        {
                                            // eslint-disable-next-line react/no-danger
                                            <span className="answer" dangerouslySetInnerHTML={{__html: translations['ipmob.landing_page.section_4.desc_2']}}/>
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className="wrapper">
                                <div className="ipm-qns-article-1">
                                    <div className="wrapper">
                                        <h4 className="qns-2">{translations['ipmob.landing_page.section_4.sub_head_3']}</h4>
                                    </div>
                                    <div className="wrapper">
                                        <span className="answer">{translations['ipmob.landing_page.section_4.desc_3']}</span>
                                    </div>
                                </div>
                                <div className="ipm-qns-article-2">
                                    <div className="wrapper">
                                        <h4 className="qns-2">{translations['ipmob.landing_page.section_4.sub_head_4']}</h4>
                                    </div>
                                    <div className="wrapper">
                                        <span className="answer">{translations['ipmob.landing_page.section_4.desc_4']}</span>
                                    </div>
                                </div>
                            </div>
                        </ipm-qns-article>
                    </ipm-landing-section>
                    <ipm-landing-section>
                        <ipm-footer/>
                    </ipm-landing-section>
                </div>
            </div>
        </div>);
    }
}

export default LandingPage;
